window.addEventListener('load', function() {
	$(".show_filter").click(function(event){
		event.preventDefault();
		$(".filter-block .searchandfilter > ul").toggleClass("show");
		$(".show_filter_btn").toggleClass("show");
	});
});
